import {Button, Typography} from '@material-ui/core';
import CoreRouteConstants from 'Core/CoreRouteConstants';
import * as React from 'react';
import {RouteComponentProps, withRouter} from 'react-router-dom';

type TErrorBoundaryState = {
  hasErrorOccurred: boolean;
};
type ErrorProps = RouteComponentProps;

export class ErrorBoundary extends React.Component<ErrorProps, TErrorBoundaryState> {
  public static getDerivedStateFromError() {
    return {
      hasErrorOccurred: true,
    };
  }

  constructor(props: ErrorProps) {
    super(props);
    this.state = {
      hasErrorOccurred: false,
    };
  }

  public componentDidCatch(error: any, info: any) {
    console.log({
      error,
      info,
    });
  }

  public render() {
    return this.state.hasErrorOccurred ? (
      <div className="error-page__container">
        <div>
          <Typography>
            An error has occurred while processing your request. <br />
            We apologize for the inconvenience. <br />
            If you need immediate assistance, please contact production support (866) 828-8074. Thank you for doing
            business with Allstate Benefits.
          </Typography>
          <Button
            onClick={() => {
              this.props.history.push(CoreRouteConstants.DASHBOARD);
              this.setState({hasErrorOccurred: false});
            }}
          >
            Return to Home
          </Button>
        </div>
      </div>
    ) : (
      this.props.children
    );
  }
}

const ErrorBoundaryWithRouter = withRouter(ErrorBoundary);

const WithComponentErrorBoundary = <TProps extends {}>(WrappedComponent: React.ComponentType<TProps>) => (
  props: TProps
) => (
  <ErrorBoundaryWithRouter>
    <WrappedComponent {...props} />
  </ErrorBoundaryWithRouter>
);

export default WithComponentErrorBoundary;
